import React from "react";
import clsx from "clsx";

const frameStyles = {
    rustic: "rounded-[20px] border-4 border-[#c49b6c] shadow-[0_5px_30px_rgba(204,160,91,0.3)] overflow-hidden",
    wood: "border-[8px] border-[#8b5e3c] rounded-xl shadow-lg bg-[#3b2f24]/30 overflow-hidden",
    glow: "rounded-xl border border-[#FFB44A] shadow-[0_0_30px_5px_rgba(255,180,74,0.3)] overflow-hidden",
    label: "relative border-2 border-primary rounded-2xl shadow-xl overflow-hidden",
};

const FramedImage = ({ src, alt = "", variant = "rustic", label, className = "" }) => {
    return (
        <div
            className={clsx(
                "transition-transform duration-300 hover:scale-[1.02] hover:shadow-2xl",
                frameStyles[variant],
                className
            )}
        >
            <img
                src={src}
                alt={alt}
                className="w-full h-full object-cover brightness-110"
                loading="lazy"
                draggable={false}
            />

            {variant === "label" && label && (
                <div className="absolute top-2 right-2 bg-primary text-black text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                    {label}
                </div>
            )}
        </div>
    );
};

export default FramedImage;